import {stringMixin} from "../../../utils/strings";
import {percentReturn} from "../../../utils/math";
import {portfolioBlotterPromptHead} from "../../../Configs/promptConfigs";

/**
 * Format the snapshot data into a readable string
 * @param snapshot {Object} Object with tickers as keys and weights as values
 * @returns {String} Formatted string of tickers and their weights
 */
export const formatSnapshotRow = (snapshot) => {
    const rows = Object.entries(snapshot).map(([ticker, data]) => [ticker, data.wgt])
        .filter(([, weight]) => weight > 0)
        .sort(([, weightA], [, weightB]) => weightB - weightA)
        .map(([ticker, weight]) => [ticker, stringMixin.pct(weight)]);
    return rows.reduce((acc, curr) => {acc[curr[0]] = curr[1];return acc;}, {});


}

/**
 * Generate a portfolio changes prompt based on the data rows
 * @param rows {Array[Array]} Array of rows with format:
 *                            [
 *                              [<timestamp>, <portfolioValue>, <snapshot>, <benchmarkValue>, <extraSymbols: Array[String]>],
 *                              [...],
 *                              ...
 *                            ]
 * @param extraHeaders {Array[String]} Headers for extra columns
 * @returns {Object} Object containing the prompt string and formatted rows
 */
export const getPortfolioChangesPrompt = (rows, extraHeaders = [], betaRows=null) => {
    const initialDate = rows[0][0];
    const initialSnapshot = formatSnapshotRow(rows[0][2]);
    const initialObject = {
        initialDate, initialSnapshot
    }
    const dataRows = [initialObject];

    // let promptString = `INSTRUCTIONS: ${portfolioBlotterPromptHead}\r\n\n`;
    // promptString += `\r\n\nDATA\r\n\nInitial Portfolio\r\nDate: ${initialDate}\r\nSnapshot: ${initialSnapshot}\r\n\n`;
    console.log(betaRows)
    const formattedRows = rows.slice(1).map((row, index) => {
        const date = row[0];
        const portfolioReturn = percentReturn(row[1], rows[0][1]);
        const benchmarkReturn = percentReturn(row[3], rows[0][3]);
        const snapshot = formatSnapshotRow(row[2]);
        let jsonObject = {
            date, portfolioReturn, benchmarkReturn, ...formatSnapshotRow(row[2])
        }
        console.log("SS", snapshot, extraHeaders)
        extraHeaders.forEach((header, idx) => {
            jsonObject[header] = percentReturn(row[3 + idx], rows[0][3 + idx]);
        })

        // const extraReturns = extraHeaders.map((header, idx) => {
        //     jsonObject[header] = percentReturn(row[3 + idx], rows[0][3 + idx]);
        //     const extraReturn = percentReturn(row[3 + idx], rows[0][3 + idx]);
        //     return `${header} % Return: ${stringMixin.pct(extraReturn)}`;
        // }).join('\r\n');

        // let betaString = '';
        if (betaRows) {
            const betaRow = betaRows.find(betaRow => betaRow.date === row[0]);
            if (betaRow) {
                betaRow.data.forEach(beta => {
                    jsonObject[`${beta.id}`] = beta.value;
                })
            }
        }
        dataRows.push(jsonObject);


        // let innerString = `Next Date: ${row[0]}\r\nSnapshot: ${formatSnapshotRow(row[2])}\r\nPortfolio Return: ${stringMixin.pct(portfolioReturn)}\r\nBenchmark Return: ${stringMixin.pct(benchmarkReturn)}\r\n`;
        // if (extraReturns) {
        //     innerString += extraReturns;
        // }
        // if (betaString) {
        //     innerString += betaString;
        // }


        // promptString += `\r\n#Next Snapshot[[${innerString}]]\r\r\n`;

        return [
            row[0], portfolioReturn, row[2], benchmarkReturn,
            ...extraHeaders.map((_, idx) => percentReturn(row[3 + idx], rows[0][3 + idx]))
        ];
    });



    const returnObject = {
        promptString: JSON.stringify({instructions: portfolioBlotterPromptHead, data: dataRows}),
        rows: [['Date', 'Portfolio Value', 'Snapshot', 'Benchmark Value', ...extraHeaders], ...formattedRows]
    };
    console.log(returnObject);
    return returnObject
};



export const stackSnapshots = (selectedPoints)=>{
    let snapshots = [];
    console.log(selectedPoints);
    selectedPoints.forEach(point=>{
        const items = point.items;
        const firstItem = items[0].data;
        const row = [...firstItem];
        for (let i=1; i<items.length; i++){
            row.push(items[i].data[1]);
        }
        snapshots.push(row);
    });
    snapshots.sort((a, b)=>a[0].localeCompare(b[0]))
    return snapshots;
}

